import { Label } from "reactstrap"

const SelectField = ({
  label,
  name,
  value,
  onChange,
  loading,
  error,
  options,
  placeholder = `Select ${label}`,
  disabled,
  renderOption,
}) => (
  <>
    {label && <Label htmlFor={name}>{label}</Label>}
    <select
      id={name}
      name={name}
      value={value ?? ""}
      onChange={onChange}
      disabled={disabled || loading}
      className={`form-select ${error ? "is-invalid" : ""}`}
    >
      <option value="">{loading ? "Loading…" : placeholder}</option>
      {Array.isArray(options) && options.length > 0 ? (
        options.map(option => {
          const value = option.id ?? option.value
          const label = renderOption ? renderOption(option) : option.name
          return (
            <option key={value} value={value}>
              {label}
            </option>
          )
        })
      ) : !loading ? (
        <option value="" disabled>
          No options available
        </option>
      ) : null}
    </select>
    {error && <div className="text-danger small mt-1">{error}</div>}
  </>
)

export default SelectField
